import array from '@mailobj-browser/front/js/utils/array.js'
import contract from '@mailobj-browser/front/js/contracts/contract.js'
import button from './button.js'
import container from './container.js'

export default contract({
  button: array([
    button
  ]),
  container: array([
    container
  ]),
})